import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface QueueGroupsData {
  data: {
    [groupName: string]: string[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class QueueService {
  private readonly QUEUE_GROUPS_URL = 'assets/data/queue-groups.json';

  constructor(private http: HttpClient) {}

  getQueueGroups(): Observable<QueueGroupsData> {
    return this.http.get<QueueGroupsData>(this.QUEUE_GROUPS_URL);
  }
}
